import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getBranches } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import BankAccountsListTable from "../../components/Tables/BankAccountsListTable";
import ManagementPageHero from "../../components/ManagementPageHero";

class BankAccounts extends React.Component {
  constructor(props) {
    super(props);
    this.qrRef = React.createRef();
    this.state = {
      accounts: [],
      branches: [],
      name: '',
      service_id: '',
      iban: '',
      bank_branch: '',
      account_no: '',
      branch_id: '',
      isLoad: true,
      loading: false,
    }
  }
  async componentDidMount() {
    window.scrollTo(0, 0);
    this.getBanks();
    this.setState({ branches: await getBranches() })
  }
  getBanks = async () => {
    try {
      const response = await apiCall('business/settings/bank-accounts', 'get', null);

      this.setState({ accounts: response }, () => {
        this.setState({ isLoad: false });
      });

    } catch (e) {
      console.log(e);
      this.setState({ isLoad: false });
    }
  }
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  handleSubmit = async () => {
    this.setState({ loading: true });
    try {
      const { name, iban, branch_id, bank_branch, account_no } = this.state;
      const response = await apiCall('business/settings/bank-account-create', 'post',
        {
          name: name,
          iban: iban,
          bank_branch: bank_branch,
          account_no: account_no,
          branch_id: branch_id,
        });
      this.getBanks();
      mainHelper.toastMessage(response.status, response.message);
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Error saving Bank Account:', error);
    }
  }

  render() {

    const { accounts, loading, branches } = this.state;
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Banka Hesapları"
              Breadcrumb={[
                { name: "Finansal İşlemler", navigate: "" },
                { name: "Banka Hesapları", navigate: "" },
              ]}
            />
            <ManagementPageHero
              eyebrow="BANKA HESAPLARI"
              title="Finans hesaplarınızı yönetin"
              description="Şubelerinize bağlı banka hesaplarını tanımlayın ve ödeme bilgilerinin güncelliğini koruyun."
            />

            <div className="row clearfix justify-content-center">
              <div className="col-lg-12">
                <div className="card">
                  <div className="body text-center">
                    <h6>Yeni Banka Hesabı Ekle</h6>
                    <div className="col-lg-12 d-flex justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <input
                            name="name"
                            id='name'
                            className="form-control"
                            placeholder="Banka Adı"
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <input
                            name="bank_branch"
                            id='bank_branch'
                            className="form-control"
                            placeholder="Banka Şube"
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <input
                            name="account_no"
                            id='account_no'
                            className="form-control"
                            placeholder="Hesap No"
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <input
                            name="iban"
                            id='iban'
                            className="form-control"
                            placeholder="İban No"
                            onChange={this.handleChange}
                          />
                        </div>

                        <div className="form-group">
                          <select name="branch_id" id='branch_id' className="form-control"
                            onChange={this.handleChange}>
                            <option value="">Şube Seçiniz</option>
                            {branches && (branches.map(branch => (
                              <option key={branch.id} value={branch.id}>{branch.name}</option>
                            )))}

                          </select>
                        </div>

                        {loading ? (
                          <button
                            className="btn btn-outline-primary btn-lg btn-block"
                            disabled={true}
                            style={{ textAlign: "-webkit-center" }}
                          >
                            Lütfen Bekleyin... <ReactLoading type="spin" color="#268bd2" width={'24px'}
                              height={'24px'} />
                          </button>
                        ) : (
                          <button
                            onClick={this.handleSubmit}
                            className="btn btn-outline-primary btn-lg btn-block"
                            type="submit"
                          >
                            Kaydet
                          </button>
                        )}

                      </div>
                    </div>
                    {accounts && (
                      <div className="col-lg-12 mt-3">
                        <BankAccountsListTable bodyData={accounts} fetchQrs={this.getBanks}></BankAccountsListTable>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
      ;
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withRouter(connect(mapStateToProps, {})(BankAccounts));
